import React from 'react';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const MONTHS = [
  { num: 1, short: 'Jan' },
  { num: 2, short: 'Fév' },
  { num: 3, short: 'Mar' },
  { num: 4, short: 'Avr' },
  { num: 5, short: 'Mai' },
  { num: 6, short: 'Juin' },
  { num: 7, short: 'Juil' },
  { num: 8, short: 'Août' },
  { num: 9, short: 'Sep' },
  { num: 10, short: 'Oct' },
  { num: 11, short: 'Nov' },
  { num: 12, short: 'Déc' },
];

export const MonthGrid = ({ selected, color, onChange, testId }) => {
  const sel = selected || [];
  return (
    <div className="grid grid-cols-6 gap-1.5" data-testid={testId}>
      {MONTHS.map((m) => {
        const active = sel.indexOf(m.num) !== -1;
        let cls = 'text-xs py-1.5 rounded border transition-colors ';
        if (active && color === 'high') cls += 'bg-orange-100 border-orange-400 text-orange-900';
        else if (active && color === 'low') cls += 'bg-sky-100 border-sky-400 text-sky-900';
        else cls += 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50';
        return (
          <button
            type="button"
            key={m.num}
            onClick={() => {
              const next = active
                ? sel.filter((x) => x !== m.num)
                : sel.concat([m.num]).sort((a, b) => a - b);
              onChange(next);
            }}
            className={cls}
            data-testid={`${testId}-month-${m.num}`}
          >
            {m.short}
          </button>
        );
      })}
    </div>
  );
};

export const NumInput = ({ id, label, suffix, value, onChange, testId }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="text-sm text-slate-700">{label}</Label>
    <div className="relative">
      <Input
        id={id}
        type="number"
        min="0"
        step="any"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="border-slate-200 focus:border-[#065F46] focus:ring-[#065F46] pr-12"
        data-testid={testId}
      />
      {suffix ? (
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-slate-400 pointer-events-none">{suffix}</span>
      ) : null}
    </div>
  </div>
);
